var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navMini"},[_c('ul',_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.changeList(index)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }